module.exports = __webpack_public_path__ + "img/yg02-02.191abf0d.png";